/**
 * @generated SignedSource<<34ed8de0fa41ebc687c00b199b8d2cd6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoEditNewMainFooterResponseText_todo$data = {
  readonly canWrite: boolean;
  readonly id: string;
  readonly isResponseCompleted: boolean;
  readonly response: {
    readonly text?: string | null;
  } | null;
  readonly status: TodoStatus;
  readonly " $fragmentType": "TodoEditNewMainFooterResponseText_todo";
};
export type TodoEditNewMainFooterResponseText_todo$key = {
  readonly " $data"?: TodoEditNewMainFooterResponseText_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainFooterResponseText_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditNewMainFooterResponseText_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canWrite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isResponseCompleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "response",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            }
          ],
          "type": "TodoResponseText",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "02e8ee878c391ea60d702ee032596613";

export default node;
